import classNames from 'classnames';
import styles from './Label.module.scss';

export interface LabelProps {
	className?: string;
	id: string;
	state?: {
		required?: boolean;
		disabled?: boolean;
		hasError?: boolean;
		isHidden?: boolean;
		hasTextNoWrap?: boolean;
	};
	children: React.ReactNode;
	labelStyle?: 'small' | 'smallWeb' | 'normalWeb';
}

export const Label: React.FC<LabelProps> = ({ className, id, children, state, labelStyle }) => (
	<label
		className={classNames(
			styles.FormLabel,
			styles[`FormLabel___${labelStyle}`],
			{ [styles.hasError]: state?.hasError },
			{ [styles.isDisabled]: state?.disabled },
			{ [styles.isHidden]: state?.isHidden },
			{ [styles.isRequired]: state?.required },
			{ [styles.hasTextNoWrap]: state?.hasTextNoWrap },
			className,
		)}
		htmlFor={id}
	>
		<span>{children}</span>
		{state?.required && (
			<span className={styles.FormLabel_requiredAsterisk} aria-hidden="true">
				&nbsp;*
			</span>
		)}
	</label>
);
